import React, { useState, useEffect } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Table } from "antd";
import axios from "axios";
import { switchEndpoint } from "../../../../redux/actions/endpoints";
import { toast } from "react-toastify";
import HistoryModal from "./modals/history";
import moment from "moment";
import { Spinner } from "react-bootstrap";
import capitalize from "../../../../capitalize";
import { storage } from "../../../../scopedStorage";

const FactoryHistory = () => {
  const [loading, setLoading] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [modalInfo, setModalInfo] = useState([]);

  const [showDrop, setShowDrop] = useState(false);
  const handleCloseDrop = () => setShowDrop(false);
  const handleShowDrop = () => setShowDrop(true);

  // null = no date filter (all history). Otherwise one of the presets below,
  // each mapped to a start_date / end_date range for the API.
  const [dateFilter, setDateFilter] = useState(null);

  const DATE_FILTERS = [
    { key: "today", label: "Today" },
    { key: "week", label: "This Week" },
    { key: "month", label: "This Month" },
  ];

  const getFilterRange = (key) => {
    if (!key) return null;
    const unit = key === "today" ? "day" : key;
    return {
      start_date: moment().startOf(unit).format("YYYY-MM-DD"),
      end_date: moment().endOf(unit).format("YYYY-MM-DD"),
    };
  };

  const safeAddAndFormat = (a, b) => {
    const numA = Number(a) || 0;
    const numB = Number(b) || 0;
    const total = numA + numB;
    return `${total.toFixed(3)}`;
  };

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15,
    total: 0,
    showSizeChanger: false,
  });

  const handleTableChange = (newPagination) => {
    getHistoryData(newPagination.current, newPagination.pageSize, dateFilter);
    setPagination((prev) => ({
      ...prev,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    }));
  };

  const handleDateFilter = (key) => {
    // Clicking the active chip clears the filter and shows all history again.
    const next = dateFilter === key ? null : key;
    setDateFilter(next);
    setPagination((prev) => ({ ...prev, current: 1 }));
    getHistoryData(1, pagination.pageSize, next);
  };


  const columns = [
    {
      title: "ID",
      dataIndex: "key",
      key: "id",
      // sorter: false,
      sorter: (a, b) => a.id - b.id,
      render: (id, record, index) => {
        ++index;
        return index;
      },
    },
    {
      title: "Weight",
      dataIndex: "",
      key: "",
      render: (text) => (
        <p className="mb-0" style={{ fontSize: "13px" }}>
          {/* {`${safeAddAndFormat(
          text?.nylon_kg,
          text?.pet_plastic_kg
        )}kg`} */}
        {text?.total_evacuated_kg}
        </p>
      ),
    },
    {
      title: "Driver",
      dataIndex: "driver_name",
      key: "driver_name",
      render: (driver) => {
        return (
          <p className="mb-0" style={{ fontSize: "13px" }}>
            {driver}
          </p>
        );
      },
    },
    {
      title: "Vehicle No",
      dataIndex: "vehicle_plate_no",
      key: "vehicle_plate_no",
    },
    {
      title: "Switch Center",
      dataIndex: "",
      key: "",
      render: (switch_center) => <p className="mb-0">{`${switch_center?.center?.name}`}</p>,
    },
    {
      title: "Date",
      dataIndex: "evacuated_at",
      key: "evacuated_at",
      render: (evacuated_at) => <p>{moment(evacuated_at).format("DD/MM/YYYY")}</p>,
    },
    {
      title: "Time",
      dataIndex: "evacuated_at",
      key: "evacuated_at",
      render: (evacuated_at) => <p>{moment(evacuated_at, "YYYY-MM-DD HH:mm:ss").format("hh:mm A")}</p>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <p className="mb-0" style={{ color: "#C4DA00" }}>{`${capitalize(status)}`}</p>,
    },
    {
      title: " ",
      key: "action",
      render: (data) => (
        <BsThreeDotsVertical
          style={{ cursor: "pointer" }}
          onClick={() => {
            setModalInfo(data);
            handleShowDrop();
            // console.log(data);
          }}
        />
      ),
    },
  ];

  const getHistoryData = (page, pageSize, filterKey = dateFilter) => {
    setLoading(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/factory/evacuation-requests?status=completed&page=${page}&pageSize=${pageSize}`, {
        headers: { Authorization: `Bearer ${token}` },
        params: getFilterRange(filterKey) || {},
      })
      .then((response) => {
        setHistoryData(response.data.data.data);
        setLoading(false);
        setPagination((prev) => ({
          ...prev,
          total: response.data.data.total,
          current: page,
        }));
        // console.log("data ==>", response.data.data);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    getHistoryData(pagination.current, pagination.pageSize);
  }, []);
  return (
    <main>
      <div className="main__container">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <span className="d-flex align-items-center py-3 px-2">
              <b>History</b>({historyData?.length || 0})
            </span>
          </div>
          <div className="d-flex align-items-center mr-2">
            {DATE_FILTERS.map(({ key, label }) => {
              const active = dateFilter === key;
              return (
                <button
                  key={key}
                  type="button"
                  disabled={loading}
                  onClick={() => handleDateFilter(key)}
                  onMouseDown={(e) => e.preventDefault()}
                  style={{
                    fontSize: "13px",
                    padding: "6px 14px",
                    marginLeft: "8px",
                    borderRadius: "6px",
                    border: `1px solid ${active ? "#c4da00" : "#d9d9d9"}`,
                    background: active ? "#c4da00" : "#fff",
                    color: active ? "#231F20" : "#606060",
                    fontWeight: active ? 600 : 400,
                    cursor: loading ? "not-allowed" : "pointer",
                    opacity: loading && !active ? 0.6 : 1,
                    outline: "none",
                    boxShadow: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  {label}
                  {active && loading && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                </button>
              );
            })}
          </div>
        </div>
        <Table
          columns={columns}
          dataSource={historyData}
          size="middle"
          loading={loading}
          pagination={pagination}
          onChange={handleTableChange}
        />
      </div>

      <HistoryModal
        showDrop={showDrop}
        handleCloseDrop={handleCloseDrop}
        loading={loading}
        modalInfo={modalInfo}
      />
    </main>
  );
};

export default FactoryHistory;
